// thunks.ts
//
// (c) NCR Voyix Corporation 2025. All rights reserved.

import { createAsyncThunk } from '@reduxjs/toolkit'
import { CancelToken } from 'axios'
import { AuthenticatedUser } from '../../common/authenticatedUser'
import { getSites, assignTagsToSites, removeTagsFromSites } from '../../data/sites'

export const getSitesData = createAsyncThunk(
  'sites/getSites',
  async (credentials: {
    userId: string;
    sessionId: string;
    dataCenter: string;
    companyId: string;
    cancelToken: CancelToken
  }) => {
    const {
      userId,
      sessionId,
      dataCenter,
      companyId,
      cancelToken
    } = credentials
    const sites = await getSites(userId, sessionId, dataCenter, companyId, cancelToken)
    return sites
  }
)

export const assignTags = createAsyncThunk(
  'sites/assignTags',
  async (args: {
    authUser: AuthenticatedUser,
    companyId: string,
    tagIds: string[],
    siteIds: string[]
  }) => {
    const {
      authUser, companyId, tagIds, siteIds
    } = args
    const updatedSites = await assignTagsToSites(
      authUser,
      companyId,
      tagIds,
      siteIds
    )
    return updatedSites
  }
)

export const removeTags = createAsyncThunk(
  'sites/removeTags',
  async (args: {
    authUser: AuthenticatedUser,
    companyId: string,
    tagIds: string[],
    siteIds: string[]
  }) => {
    const {
      authUser, companyId, tagIds, siteIds
    } = args
    const updatedSites = await removeTagsFromSites(
      authUser,
      companyId,
      tagIds,
      siteIds
    )
    return updatedSites
  }
)
